import util from '@bmp-vue/core/api/util'

const controller = 'SolicitacaoMfaRetaguarda'
export default Object.assign({}, util.GetCrud(controller, null), {
  CriarSolicitacao: function (dto) {
    return util.Axios.Post(controller + '/CriarSolicitacao', dto)
  },
  ConcluirSolicitacao: function () {
    return util.Axios.Post(controller + '/ConcluirSolicitacao')
  },
  MudarSituacaoSolicitacao: function (dto) {
    return util.Axios.Put(controller + '/MudarSituacaoSolicitacao', null, dto)
  },
  GetSituacaoSolicitacao: function () {
    return util.Axios.Get(controller + '/GetSituacaoSolicitacaoByOperador')
  }
})
